import { Link } from "react-router-dom";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { subStrConversionMessage } from "../../../helpers/Functions";
import { MessageType } from "../../../helpers/Enums";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setConversation } from "../../../redux/carpet";
import ConversationGift from "./ConversationGift";
import { IsEmptyOrNullString } from "../../../helpers/Strings";

export interface ConverstionItemProps {
  memberImageUrl: string;
  lastMessage: string;
  memberName: string;
  memberCode: number;
  messageTypeId: MessageType;
  newMessagesCount: number;
  userName: string;
  lastMessageBy: number | null;
  firstSenderMemberCode?: number;
  stickerId?: number;
  stickerImageUrl?: string | null;
}

const ConverstionItem = ({
  messageTypeId,
  newMessagesCount,
  memberCode,
  lastMessage,
  memberName,
  memberImageUrl,
  userName,
  lastMessageBy,
  firstSenderMemberCode,
  stickerId,
  stickerImageUrl,
}: ConverstionItemProps) => {
  const myMemberCode = useSelector(
    (state: RootState) => state.member.memberCode
  );
  const conversationList = useSelector(
    (state: RootState) => state.carpet.conversation
  );
  const dispatch = useDispatch();

  const imageArray = {
    [MessageType.Image]: {
      title: "תמונה",
      url: "/assets/images/ic_txt_pict.svg",
    },
    [MessageType.ProfileImages]: {
      title: "תמונה",
      url: "/assets/images/ic_txt_pict.svg",
    },
    [MessageType.Location]: {
      title: "מיקום",
      url: "/assets/images/ic_txt_place.svg",
    },
    [MessageType.BreakTheIce]: {
      title: "שבור את הקרח",
      url: "/assets/images/ic_txt_ice.svg",
    },
    [MessageType.Text]: {
      title: subStrConversionMessage(lastMessage),
      url: null,
    },
    [MessageType.Video]: {
      title: "סרטון",
      url: null,
    },
    [MessageType.Audio]: {
      title: "אודיו",
      url: null,
    },
  };

  const messageData = imageArray[messageTypeId];

  const link = usePrepareLink({
    state: {
      navigateFromProfile: false,
      memberName: memberName,
      memberImage: memberImageUrl,
      userName: userName,
    },
    query: {
      [GET_PARAMS.memberCode]: memberCode,
    },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.chat,
    },
    keepOldQuery: true,
  });

  return (
    <li className="messages_item">
      <Link to={link} className="messages_link w-inline-block">
        <div className="messages_pict_block">
          <div className="messages_pict">
            {memberImageUrl && (
              <img
                src={memberImageUrl}
                loading="lazy"
                alt=""
                className="item_pict"
              />
            )}
          </div>
        </div>
        <div className="messages_infogroup w-clearfix">
          <h4 className="messages_info_title">{userName}</h4>
          {messageData.url ? (
            <img
              src={messageData.url}
              loading="lazy"
              alt=""
              className="message_icon"
            ></img>
          ) : null}

          {messageData.title.length > 30 ? (
            <div className="message_txt">
              {messageData.title.slice(0, 30)}...
            </div>
          ) : (
            <div className="message_txt">{messageData.title}</div>
          )}
          {lastMessageBy === memberCode && (
            <div className="massages_info_flah">הכדור אצלך</div>
          )}
        </div>

        {/* {newMessagesCount > 0 ? (
          <div>
            <div className="message_num list">
              <div>{newMessagesCount}</div>
            </div>
            <ConversationGift
              stickerId={stickerId}
              stickerImageUrl={stickerImageUrl}
            />
          </div>
        ) : (
          lastMessageBy === memberCode && (
            <div>
              <div className="message_num list">
                <div>הכדור אצלך</div>
              </div>
              <ConversationGift
                stickerId={stickerId}
                stickerImageUrl={stickerImageUrl}
              />
            </div>
          )
        )} */}

        {/* <div>
          {(newMessagesCount > 0 || lastMessageBy === memberCode) && (
            <div className="message_num list">
              {newMessagesCount > 0 ? (
                <div>{newMessagesCount}</div>
              ) : (
                <div>הכדור אצלך</div>
              )}
            </div>
          )}
          <ConversationGift
            stickerId={stickerId}
            stickerImageUrl={stickerImageUrl}
          />
        </div> */}

        <div>
          {/* {newMessagesCount > 0 && (
            <div className="message_num list">
              <div>{newMessagesCount}</div>
            </div>
          )} */}

          {/* {stickerId !== -1 && (
            <div className="message_num list">
              {lastMessageBy === memberCode ? "שלחתי מתנה" : "קיבלתי מתנה"}
            </div>
          )} */}

          {(newMessagesCount > 0 ||
            !IsEmptyOrNullString(stickerImageUrl as string)) && (
            <div className="message_num list">
              {newMessagesCount > 0 ? (
                <div>{newMessagesCount}</div>
              ) : !IsEmptyOrNullString(stickerImageUrl as string) ? (
                myMemberCode === firstSenderMemberCode ? (
                  "שלחתי מתנה"
                ) : (
                  "קיבלתי מתנה"
                )
              ) : null}
            </div>
          )}

          <ConversationGift
            stickerId={stickerId}
            stickerImageUrl={stickerImageUrl}
          />
        </div>

        {/* <div className="message_num list">
          {newMessagesCount > 0 && <div>{newMessagesCount}</div>}

          <ConversationGift
            stickerId={stickerId}
            stickerImageUrl={stickerImageUrl}
          />
        </div> */}

        {/* <div>
          <div className="message_num list">
            {newMessagesCount > 0 ? (
              <div>{newMessagesCount}</div>
            ) : lastMessageBy === memberCode ? (
              <div>הכדור אצלך</div>
            ) : null}
          </div>
          <ConversationGift
            stickerId={stickerId}
            stickerImageUrl={stickerImageUrl}
          />
        </div> */}

        {/* <div>
          <div className="message_num list">
            {newMessagesCount > 0 ? (
              <div>{newMessagesCount}</div>
            ) : (
              lastMessageBy === memberCode && <div>הכדור אצלך</div>
            )}
          </div>
          {(newMessagesCount > 0 || lastMessageBy === memberCode) && (
            <ConversationGift stickerId={stickerId} />
          )}
        </div> */}
      </Link>
    </li>
  );
};

export default ConverstionItem;
